<script setup lang="ts">
import type { StickerFill, StickerTilt } from './SfgSticker.vue'

withDefaults(defineProps<{
  artFill?: StickerFill
  duration?: string
  format?: 'Cooperative' | 'Individual' | 'Teams'
  playerNote?: string
  status?: 'live' | 'soon'
  stickerBottom?: string
  stickerTilt?: StickerTilt
  stickerTop?: string
  title: string
  type?: readonly ('Knowledge' | 'Skills')[]
}>(), {
  artFill: 'yellow',
  duration: undefined,
  format: undefined,
  playerNote: undefined,
  status: 'live',
  stickerBottom: undefined,
  stickerTilt: 1,
  stickerTop: undefined,
  type: undefined,
})
</script>

<template>
  <article class="group flex flex-col rounded-card overflow-hidden border-[1.5px] border-brand-ink bg-brand-chalk">
    <!-- Art panel (dark, sticker inside) -->
    <div class="sfg-sheet-texture relative flex items-center justify-center min-h-55 lg:min-h-65 xl:min-h-70 p-8">
      <div class="scale-100 lg:scale-125 xl:scale-[1.4] origin-center">
        <SfgStickerBanner
          v-if="stickerTop || stickerBottom"
          :top-line="stickerTop"
          :bottom-line="stickerBottom"
          :fill="artFill"
          :tilt="stickerTilt"
          size="sm"
        />
      </div>
      <SfgBadge :variant="status" class="absolute top-3 right-3">
        {{ status === 'live' ? 'Live' : 'Soon' }}
      </SfgBadge>
    </div>

    <!-- Info strip -->
    <div class="flex items-start justify-between gap-3 p-4 border-t-[1.5px] border-brand-ink">
      <div class="min-w-0 flex-1">
        <h4 class="font-display uppercase text-[15px] tracking-[0.08em] text-brand-ink">
          {{ title }}
        </h4>
        <div v-if="type?.length" class="flex flex-wrap gap-1.5 mt-2">
          <span
            v-for="t in type"
            :key="t"
            class="font-display uppercase text-[10px] tracking-[0.12em] px-2 py-0.5 rounded-pill border border-brand-ink/30 text-brand-ink/80 leading-none whitespace-nowrap"
          >
            {{ t }}
          </span>
        </div>
        <p v-if="format || playerNote" class="font-body text-[11px] text-brand-ink/60 mt-1.5">
          <span v-if="format">{{ format }}</span>
          <span v-if="format && playerNote"> · </span>
          <span v-if="playerNote">{{ playerNote }}</span>
        </p>
      </div>
      <span
        class="font-display uppercase text-[13px] tracking-[0.14em] px-3 py-2 rounded-pill flex items-center gap-1 shrink-0"
        :class="status === 'live' ? 'bg-brand-ink text-brand-yellow' : 'text-brand-ink/40'"
      >
        {{ status === 'live' ? '▶ Play' : 'Soon' }}
      </span>
    </div>
  </article>
</template>
